import PropTypes from 'prop-types';
import { Tooltip as ReactTooltip } from 'react-tooltip';

const Tooltip = ({ id, children }) => (
  <ReactTooltip id={id} place="bottom">
    {children}
  </ReactTooltip>
);

Tooltip.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Tooltip;
